import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { ProductCountWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { ItemCount } from '@src/components/widgets/item-count'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

/**
 * Standalone product-count widget.
 *
 * Previously the product count was rendered inside the FILTER_AND_SORT widget (mobile only),
 * which constrained where it could sit in the mobile layout. It is now its own PL widget so the
 * backend can position it independently. It reuses `ItemCount` unchanged, so the count's styling
 * and surrounding spacing are identical to the legacy in-filter rendering — keeping inter-widget
 * gaps the same.
 */
const ProductCountWidgetComponent = (props: PLTypedWidgetProps<ProductCountWidgetData>) => {
  const data = props.data.productCountData
  const { deviceType } = useDeviceInfo()
  const isMobile = deviceType === DEVICE_TYPES.MOBILE

  return <ItemCount totalItems={data?.total ?? 0} isMobile={isMobile} />
}

export const ProductCountWidget: PLTypedWidgetInterface<ProductCountWidgetData, WidgetType.PRODUCT_COUNT> = {
  id: WidgetType.PRODUCT_COUNT,
  errorBoundary: PLBaseErrorBoundary,
  render: ProductCountWidgetComponent,
}
